module.exports = __webpack_public_path__ + "img/logo_horizontal_white.8d52eb0e.svg";